import {apiInstance} from '../api_Instance';
import {queryOptions} from '@tanstack/react-query';

export const threadApi = {
  getThread: () => {
    return queryOptions({
      queryKey: ['thread', 'list'],
      queryFn: () => apiInstance.get(`/threads/`),
    });
  },
};
